// extracted by mini-css-extract-plugin
export default {"imageContent":"Am-z","modal":"Bm-z"};